import { Alert } from 'antd';
import type { ReactNode } from 'react';

import styles from './styles.module.less';

export type TWorkJourneyCoverConflictAlertVariant = 'error' | 'info';

interface WorkJourneyCoverConflictAlertProps {
  title: ReactNode;
  description: ReactNode;
  variant?: TWorkJourneyCoverConflictAlertVariant;
}

export const WorkJourneyCoverConflictAlert = ({
  title,
  description,
  variant = 'error',
}: WorkJourneyCoverConflictAlertProps) => (
  <Alert
    type={variant === 'info' ? 'info' : 'error'}
    showIcon={false}
    className={variant === 'info' ? styles.conflictAlertInfo : styles.conflictAlert}
    message={<span className={variant === 'info' ? styles.conflictTitleInfo : styles.conflictTitle}>{title}</span>}
    description={
      <div
        className={
          variant === 'info' ? styles.conflictDescriptionInfo : styles.conflictDescription
        }
      >
        {description}
      </div>
    }
  />
);
